import { Icon, Tooltip } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { IconName } from "src/globalTypes";
import { ListItem } from "./styles";

type Props = {
  iconName: IconName;
  tooltip: string;
  onClick?(): void;
  linkTo?: string;
};

const NavItem = ({ iconName, tooltip, onClick, linkTo }: Props) => {
  if (linkTo)
    return (
      <ListItem>
        <Tooltip title={tooltip} placement="top-end">
          <Link to={linkTo} aria-label={tooltip}>
            <Icon>{iconName}</Icon>
          </Link>
        </Tooltip>
      </ListItem>
    );

  return (
    <ListItem>
      <Tooltip title={tooltip} placement="top-end">
        <button type="button" onClick={onClick} aria-label={tooltip}>
          <Icon>{iconName}</Icon>
        </button>
      </Tooltip>
    </ListItem>
  );
};

export default NavItem;
